/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Everydayneedstimerange4Inputs */

const en_everydayneedstimerange4 = /** @type {(inputs: Everydayneedstimerange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every day needs a start and end time`)
};

const de_everydayneedstimerange4 = /** @type {(inputs: Everydayneedstimerange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für jeden Tag muss eine Start- und Endzeit gesetzt sein`)
};

/**
* | output |
* | --- |
* | "Every day needs a start and end time" |
*
* @param {Everydayneedstimerange4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const everydayneedstimerange4 = /** @type {((inputs?: Everydayneedstimerange4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Everydayneedstimerange4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_everydayneedstimerange4(inputs)
	return de_everydayneedstimerange4(inputs)
});
export { everydayneedstimerange4 as "everyDayNeedsTimeRange" }